import React from 'react';
import DeckAnalysis from './DeckAnalysis';

const DeckStats = ({ stats, deck }) => {
  const {
    totalCards,
    championCount,
    unitCount,
    spellCount,
    gearCount,
    battlefieldCount,
    runeCount,
    costDistribution,
    isValid
  } = stats;

  // Calculate card type distribution
  const totalMainCards = unitCount + spellCount + gearCount;
  const unitPercentage = totalMainCards > 0 ? Math.round((unitCount / totalMainCards) * 100) : 0;
  const spellPercentage = totalMainCards > 0 ? Math.round((spellCount / totalMainCards) * 100) : 0;
  const gearPercentage = totalMainCards > 0 ? Math.round((gearCount / totalMainCards) * 100) : 0;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className={`bg-background/30 p-3 rounded-lg ${!isValid ? 'border border-red-500/50' : ''}`}>
          <div className="text-xs text-muted-foreground">Main Deck</div>
          <div className={`text-lg font-bold ${totalCards < 40 ? 'text-red-500' : ''}`}>
            {totalCards}/40+
          </div>
        </div>
        <div className="bg-background/30 p-3 rounded-lg">
          <div className="text-xs text-muted-foreground">Champions</div>
          <div className="text-lg font-bold">{championCount}</div>
        </div>
        <div className="bg-background/30 p-3 rounded-lg">
          <div className="text-xs text-muted-foreground">Battlefields</div>
          <div className={`text-lg font-bold ${battlefieldCount > 3 ? 'text-red-500' : ''}`}>
            {battlefieldCount}/3
          </div>
        </div>
        <div className="bg-background/30 p-3 rounded-lg">
          <div className="text-xs text-muted-foreground">Runes</div>
          <div className={`text-lg font-bold ${runeCount !== 12 ? 'text-red-500' : ''}`}>
            {runeCount}/12
          </div>
        </div>
      </div>

      {/* Validation Status */}
      <div className={`p-3 rounded-lg ${isValid ? 'bg-green-500/20 border border-green-500/50' : 'bg-red-500/20 border border-red-500/50'}`}>
        <div className="font-semibold flex items-center gap-2">
          <span>{isValid ? '✓' : '✗'}</span>
          <span>{isValid ? 'Valid Deck' : 'Invalid Deck'}</span>
        </div>
        <p className="text-sm mt-1">
          {isValid
            ?     'This deck meets all official Riftbound rules requirements'
            : 'Please fix the validation errors to make this deck valid'}
        </p>
      </div>

      {/* Detailed Analysis */}
      <DeckAnalysis stats={stats} deck={deck} />
    </div>
  );
};

export default DeckStats;